import axios from 'axios';
import base from './axiosBaseUrl';

const instance = axios.create({
  baseURL: base + '/api/gci_exceptions/'
});

instance.interceptors.request.use(function(config) {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

instance.interceptors.response.use(function(response) {
  return response;
}, function(error) {
  if (error.response && error.response.status === 401) {
    window.location.href = '/pages/login-page';
  }
  return Promise.reject(error);
});

export default instance;
